<template lang="html">

  <section class="game-list">
    <AdminHeader></AdminHeader>
    <h1 class="mb-5">Spiele</h1>
    <v-list>
      <v-list-item-group>
        <router-link to="/admin/games/add">
          <v-list-item>
            <v-list-item-title class="add_game">
              <v-icon>mdi-plus</v-icon>
              Spiel Hinzufügen
            </v-list-item-title>
          </v-list-item>
        </router-link>
        <span v-bind:key="game.id" v-for="game in games" class="game_list_item">

            <v-list-item>
              <v-list-item-title>{{ game.name.de }}</v-list-item-title>
               <v-btn :to="{ name: 'editGame', params: { slug: game.slug}}">Bearbeiten</v-btn>
              <v-btn @click="deleteGame(game.id)">Löschen</v-btn>
            </v-list-item>

        </span>
      </v-list-item-group>
    </v-list>
  </section>

</template>

<script lang="js">
import AdminHeader from "./AdminHeader";
import GameService from "../../services/GameService";

export default {
  name:       'game-list',
  components: {AdminHeader},
  props:      [],
  mounted () {
    this.getGames();
  },
  data () {
    return {
      'games': [],
    }
  },
  methods:    {
    getGames () {
      GameService.getGames().then(res => {
        console.log(res);
        this.games = res.data;
      })
                 .catch(err => console.log(err));
    },
    deleteGame(id){
      GameService.deleteGame(id).then(() => {
        const game = this.games.find(game => game.id === id);
        const index = this.games.indexOf(game);
        this.games.splice(index, 1);
      });
    }
  },
  computed:   {}
}


</script>

<style scoped lang="scss">
.game-list {

}

.add_game, .add_game i {
  color: var(--v-primary-base) !important;
}

a {
  text-decoration: none !important;
}

</style>
